import { useCallback } from 'react';
import { useRouter } from 'next/router';
import { removeQueryParams } from '@framework/router';
import { useFilterActions } from '@/creditflowresearch/application/Research/useFilterActions';
import { IResearchFilterState } from '@/creditflowresearch/domain/vo/research/IFilterContextData';
import { IFilterProcessingResult } from '@/creditflowresearch/application/Research/types';

const HASH_PARAM = 'hash';

export const useHashFilterProcessing = () => {
  const { query: routeParams, push } = useRouter();
  const {
    getResearchFiltersInitialState,
    getFiltersPayload,
    getResearchFilterByHash,
  } = useFilterActions();

  const removeHashFromUrl = useCallback(() => {
    const newQuery = removeQueryParams(routeParams, [HASH_PARAM]);
    push({ query: newQuery }, undefined, { shallow: true });
  }, [routeParams, push]);

  return useCallback(async (): Promise<IFilterProcessingResult> => {
    const filtersState = getResearchFiltersInitialState();
    let filtersPayload: IResearchFilterState = getFiltersPayload(filtersState);
    let isHashFiltersPayload = false;

    if (HASH_PARAM in routeParams) {
      try {
        const hashPayload = await getResearchFilterByHash(routeParams.hash as string);

        if (hashPayload) {
          isHashFiltersPayload = true;
          filtersPayload = hashPayload;
        } else {
          removeHashFromUrl();
        }
      } catch (err) {
        removeHashFromUrl();
      }
    }

    return {
      isHashFiltersPayload,
      filtersState,
      filtersPayload,
    };
  }, [routeParams, getResearchFiltersInitialState, getFiltersPayload, getResearchFilterByHash, removeHashFromUrl]);
};
